















import { defineComponent, onMounted, ref, PropType, onBeforeUnmount } from 'vue-demi';
import { useGetter } from 'common-module/src/util/useVuex';

export default defineComponent({
  name: 'RecordLoadingComponent',
  components: {

  },
  props: {
    recordUpload: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({})
    }
  },
  setup(props, { emit }) {


    const progress = ref(0);
    
    //做一个假的加载
    const timer = setInterval(() => {
      progress.value = progress.value + 1;
      if (progress.value > 30) {
        clearInterval(timer);
      }
    }, 100);

    const uploadResult = ref({});
    

    // 监听上传进度
    const onProgressChange = (currentProgress: number) => {
      timer && clearInterval(timer);
      const value = currentProgress * 100 | 0;
      progress.value = value < progress.value ? progress.value : value;
    };
 
    const onUploadStatusChange = ({ status, data } : { status: string; data: Record<string, any>}) => {
      console.log(status, data, 'onUploadStatusChange');
      if (status === 'success') {
        const { id, videoUrl, videoCode, fileId, issueId } = data;
        const videoAuthor = JSON.stringify({ avatar: useGetter('user/avatar'), name: useGetter('user/userName') });
        
        uploadResult.value = {
          id,
          fileId,
          videoUrl,
          videoCode,
          issueId,
          videoName: props.recordUpload?.recorderResult?.fileName,
          videoAuthor,
          audioText: props.recordUpload?.recorderResult?.text
        };
        emit('success', uploadResult.value);
      } else if (status === 'fail') {
        console.log('fail');
        emit('fail');
      }
    };


    const init = () => {
      const recordUploadInstance = props.recordUpload;
      console.log(recordUploadInstance, 'props.recordUpload');
      if (!recordUploadInstance) {
        return;
      }
      
      const { fileName, text, from, fileSuffix, status } = recordUploadInstance;

      console.log(fileName, text, from, fileSuffix);
      if (status === 'fail') {
        emit('fail');
      }
      recordUploadInstance.on('uploadProgress', onProgressChange);
      recordUploadInstance.on('uploadStatusChange', onUploadStatusChange);
    };

    onMounted(
      () => {
        init();
      }
    );

    onBeforeUnmount(
      () => {
        clearInterval(timer);
      }
    );

    return {
      progress
    };

  }
});
